angular.module('tgaApp').service('gameService', [
  '$http',
  'envService',
  'domainService',
  'authService',
  function ($http, envService, domainService, authService) {
    const serverAddress = envService.read('serverAddress');
    const useCachingServer = envService.read('useCaching');
    let cachingServerAddress = useCachingServer ? envService.read('cachingServerAddress') : null;
    let games = null;
    let game_id = null;

    function getGame(data) {
      return $http({
        method: 'GET',
        url: `${cachingServerAddress ?? serverAddress}game`,
        params: {
          domain: domainService.domain,
          game_id: data.game_id,
          slug: data.slug,
          language_id: data.language_id,
          token: data.token,
        },
      }).then(
        (response) => {
          game_id = response.data.game_id;
          // filter out custom fields with a 'disabled' status
          response.data.registration.custom_fields = response.data.registration.custom_fields.filter(
            (f) => f.condition !== 'disabled',
          );
          return response.data;
        },
        (error) => {
          if (cachingServerAddress) {
            cachingServerAddress = null;
            return getGame(data);
          }
          throw error.data;
        },
      );
    }

    function getGameId() {
      return game_id;
    }

    function getGameData() {
      return $http({
        method: 'GET',
        url: './data/gridmatch.json',
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getGames() {
      if (!games) {
        games = $http({
          method: 'GET',
          url: `${serverAddress}game`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }
      return games;
    }

    function addGame(data) {
      // Clear games cache
      games = null;

      data.domain = domainService.domain;

      return $http({
        method: 'POST',
        url: `${serverAddress}game`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function updateGame(data) {
      // Clear games cache
      games = null;

      return $http({
        method: 'PUT',
        url: `${serverAddress}game`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function deleteGame(gameId) {
      // Clear games cache
      games = null;

      return $http({
        method: 'DELETE',
        url: `${serverAddress}game/${gameId}`,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getQuestion(questionId) {
      return $http({
        method: 'GET',
        url: `${serverAddress}question/${questionId}`,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getQuestions(gameId) {
      return $http({
        method: 'GET',
        url: `${serverAddress}question`,
        params: {
          game_id: gameId,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function addQuestion(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}question`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function updateQuestion(data) {
      return $http({
        method: 'PUT',
        url: `${serverAddress}question`,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getTracks() {
      return $http({
        method: 'GET',
        url: `${serverAddress}game/tracks`,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getFields() {
      return $http({
        method: 'GET',
        url: `${serverAddress}game/fields`,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getScormUrl(gameId, version) {
      return (
        `${serverAddress
        }game/scorm/${
          gameId
        }/?X-TGA-KEY=${
          authService.getAuthentication().token
        }&domain=${
          domainService.domain
        }&version=${
          version}`
      );
    }

    return {
      getGame,
      getGameData,
      getGames,
      addGame,
      updateGame,
      deleteGame,
      getQuestion,
      getQuestions,
      addQuestion,
      updateQuestion,
      getTracks,
      getFields,
      getScormUrl,
      getGameId,
    };
  },
]);
